export default {
    welcomeGreeting: "Välkommen!",
    welcomeMessage: "Kul att du ska testa Bwell-metoden.\nLycka till!",
    startButton: "Sätt igång",
    subtext: "Börja din välmående-resa idag"
  };